export default "__VITE_ASSET__CvYK6OQ5__"